"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLocalizer;

var _react = require("react");

var _getAllLocalizedStrings = _interopRequireDefault(require("../Localization/getAllLocalizedStrings"));

var _useLocalizedGlobalize = _interopRequireDefault(require("./internal/useLocalizedGlobalize"));

var _useLocalizedStrings = _interopRequireDefault(require("./internal/useLocalizedStrings"));

var _isObject = _interopRequireDefault(require("../Utils/isObject"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DEFAULT_STRINGS = (0, _getAllLocalizedStrings.default)()['en-US'];

function useLocalizer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      plural = _ref.plural;

  var _useLocalizedGlobaliz = (0, _useLocalizedGlobalize.default)(),
      _useLocalizedGlobaliz2 = _slicedToArray(_useLocalizedGlobaliz, 1),
      globalize = _useLocalizedGlobaliz2[0];

  var localizedStrings = (0, _useLocalizedStrings.default)();
  return (0, _react.useCallback)(function (id) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (plural) {
      if (!(0, _isObject.default)(id)) {
        throw new Error('useLocalizer: Plural string must pass "id" as a map instead of string.');
      } else if (typeof id.other !== 'string') {
        throw new Error('useLocalizer: Plural string must have "id.other" of string.');
      } else if (typeof args[0] !== 'number') {
        throw new Error('useLocalizer: Plural string must have first argument as a number.');
      }

      for (var _i2 = 0, _arr2 = ['zero', 'one', 'two', 'few', 'many']; _i2 < _arr2.length; _i2++) {
        var pluralForm = _arr2[_i2];

        var type = _typeof(id[pluralForm]);

        if (type !== 'string' && type !== 'undefined') {
          throw new Error("useLocalizer: Plural string must have \"id.".concat(pluralForm, "\" of string or undefined."));
        }
      }

      var unsupportedPluralForms = Object.keys(id).filter(function (pluralForm) {
        return !['zero', 'one', 'two', 'few', 'many', 'other'].includes(pluralForm);
      });

      if (unsupportedPluralForms.length) {
        throw new Error("useLocalizer: Plural string \"id\" must be either \"zero\", \"one\", \"two\", \"few\", \"many\", \"other\". But not ".concat(unsupportedPluralForms.map(function (pluralForm) {
          return "\"".concat(pluralForm, "\"");
        }).join(', '), "."));
      }

      id = id[globalize.plural(args[0])] || id.other;
    } else if (typeof id !== 'string') {
      throw new Error('useLocalizer: "id" must be a string.');
    }

    return Object.entries(args).reduce(function (str, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          index = _ref3[0],
          arg = _ref3[1];

      return str.replace("$".concat(+index + 1), arg);
    }, localizedStrings[id] || DEFAULT_STRINGS[id] || '');
  }, [globalize, localizedStrings, plural]);
}